import { Box, Heading, Stack } from "@eworkit/iris";
import { Formik, FormikHelpers, FormikProps } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { AnimatedLayoutModal } from "@/components/animated-layout";
import { IInvitation } from "@/data/invitations";
import {
  FORM_EMPTY_INITIAL_VALUES,
  ISignUpUserFormValues,
  SignUpUserForm,
  validationSchema,
} from "@/views/components/Forms/SignUpUserForm";

interface IInvitationSignUpFormProps {
  form: FormikProps<ISignUpUserFormValues>;
  onCancel?: () => void;
}

export const InvitationSignUpForm: FC<IInvitationSignUpFormProps> = ({ form, onCancel }) => {
  const { t } = useTranslation("public");

  return (
    <AnimatedLayoutModal>
      <Box px={["sm", null, "xxl"]}>
        <Stack gap="md">
          <Heading size="h-md" align="center">
            {t("SESSION_INVITATION.SIGN_UP_HEADER")}
          </Heading>

          <SignUpUserForm form={form} hideEmailInput onCancel={onCancel} />
        </Stack>
      </Box>
    </AnimatedLayoutModal>
  );
};

interface IInvitationSignUpFormikProps {
  invitation: IInvitation;
  onSubmit: (values: ISignUpUserFormValues, actions: FormikHelpers<ISignUpUserFormValues>) => Promise<void>;
  onCancel?: () => void;
}

export const InvitationSignUpFormik: FC<IInvitationSignUpFormikProps> = ({ invitation, onSubmit, ...restProps }) => {
  return (
    <Formik
      initialValues={{
        ...FORM_EMPTY_INITIAL_VALUES,
        firstName: invitation.firstName,
        lastName: invitation.lastName,
        email: invitation.email,
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmit}>
      {(form: FormikProps<ISignUpUserFormValues>) => <InvitationSignUpForm form={form} {...restProps} />}
    </Formik>
  );
};
